export const isTenantHomeViewer = (entityType?: string) =>
  entityType?.trim().toUpperCase() === 'TENANT'
